import { defineStore } from 'pinia'
import { readonly, ref, Ref } from 'vue'

import { useLocalization } from '@/shared/composables/localization'
import { getAppURL } from '@/shared/utils/electron'
import { useFetchApi } from '@/shared/utils/fetch'

import { AuthorizedSession } from '.'

export const useAuthorizedSessionsStore = defineStore('authorized-sessions', () => {
  const sessions: Ref<AuthorizedSession[]> = ref([])

  const { get, delete: deleteRequest } = useFetchApi()
  const { t } = useLocalization()

  const fetch = async () => {
    try {
      const { data = [] } = await get<AuthorizedSession[]>(getAppURL({ pathName: '/api/user/devices' }))
      sessions.value = data.filter(({ sessionId }) => !!sessionId)
      return data
    } catch (err) {
      throw new Error(t('common.failedToLoadList', { err }))
    }
  }

  const deleteSession = async (sessionId: string) => {
    try {
      await deleteRequest(getAppURL({ pathName: `/api/user/device/${sessionId}` }))

      sessions.value = sessions.value.filter(s => s.sessionId !== sessionId)
    } catch (err) {
      throw new Error(t('common.failedToLoadList', { err }))
    }
  }

  return {
    fetch,
    deleteSession,
    sessions: readonly(sessions),
  }
})
